module.exports = __webpack_public_path__ + "img/nodata.f122c062.png";